<template>
  <div id="basketball_playerDetail_careeData">
    <div class="select_row_box">
      <SelectItem
        v-for="selectItem in selectList"
        :key="selectItem.state"
        :options="selectItem"
        :curVal="selectItem.curVal"
        @changeValEvent="selectChangeVal"
      ></SelectItem>
    </div>
    <div class="group_container" ref="tableParentDom">
      <div class="table_container">
        <nodeTree_table
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :tableMode="tableMode"
          :parentWidthPx="parentWidthPx"
          :isScrollFlag="isScrollFlag"
          :isClickFlag="isClickFlag"
          :variableColWidthVw="variableColWidthVw"
          :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
          :defaultWidthVwNum="defaultWidthVwNum"
          :tableColumnData="tableColumnData"
          :tableData="tableData"
          :tableHeightPx="0"
          :jumpRouterPathNames="jumpRouterPathNames"
          :cellClassName="cellClassName"
          :arraySpanMethod="arraySpanMethod"
          :tableCustomCellRender="tableCustomCellRender"
          valFormatReturnDefaultVal="- -"
          v-show="tableData && tableData.length > 0"
        ></nodeTree_table>
      </div>
      <cup_notData
        v-show="tableData && tableData.length === 0"
        className="relativePtb60"
      ></cup_notData>
    </div>
  </div>
</template>
<script>
import { https_playerDetail_careerData } from '@api/platfrom_basketball_api'

import SelectItem from '@components/platfromBase/basketball/selectItem.vue'
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import cup_notData from '@components/base/NO_DATA.vue'

export default {
  name: 'basketball_playerDetail_careeData',
  components: { SelectItem, nodeTree_table, cup_notData },
  mixins: [cup_base_data_mixin],
  props: {
    matchInfor: {
      type: Object,
      default: () => ({
        teamId: '',
        teamName: '',
        teamLogo: '',
        teamWin: '',
        teamLosses: '',
        teamRank: '',
      }),
    },
  },
  data() {
    return {
      loading: false,
      tableMode: 'teamData',
      jumpRouterPathNames: {
        pathName_teamDetail: 'teamDetailIndex',
        pathName_playerDetail: 'playerDetailIndex',
      },
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: true,
      isClickFlag: false,
      variableColWidthVw: 6.94,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableCustomCellRender: {
        props: ['fieldGoals', 'freethrows', 'threePoints', 'twoPoints'],
        classNames: [
          'flexCloCenter',
          'flexCloCenter',
          'flexCloCenter',
          'flexCloCenter',
        ],
      },
      selectList: [
        {
          list: [
            {
              id: '1',
              name: '常规赛',
            },
            {
              id: '2',
              name: '季后赛',
            },
            {
              id: '9',
              name: '保级赛',
            },
          ],
          keyValArr: ['id', 'name'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 9.74,
          curVal: '',
          state: 'phaseType',
        },
        {
          list: [
            {
              id: 'sum',
              name: '总和',
            },
            {
              id: 'avg',
              name: '场均数据',
            },
          ],
          keyValArr: ['id', 'name'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 9.74,
          curVal: '',
          state: 'statsType',
        },
      ],
      curSelect_phaseType: '1',
      curSelect_statsType: 'avg',
    }
  },
  watch: {
    $route(to, from) {
      // 监听路由变化，矫正 tab 选中状态
      console.debug('$route:', from.query, to.query)
      if (JSON.stringify(from.query) !== JSON.stringify(to.query)) {
        // 头部切换球员时刷新数据
        this.query = to.query
        this.init()
      }
    },
  },
  created() {
    if (this.currThemeObj) {
      const moduleRouteNameEn = this.currThemeObj.moduleRouteNameEn
      this.jumpRouterPathNames = {
        pathName_teamDetail: `teamDetailIndex_${moduleRouteNameEn}`,
        pathName_playerDetail: `playerDetailIndex_${moduleRouteNameEn}`,
      }
    }
    this.query = this.$route.query
    this.init()
  },
  mounted() {
    this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
    console.debug('this.parentWidthPx:', this.$refs.tableParentDom.scrollHeight)
  },
  computed: {},
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      setTimeout(() => {
        this.initSelectOpt()
      }, 100)
      await this.getPlayerDetailCereerList()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    initSelectOpt() {
      let selectList = JSON.parse(JSON.stringify(this.selectList))
      this.selectList = selectList.map((item) => {
        if (item) {
          item.curVal = this[`curSelect_${item.state}`]
        }
        return item
      })
    },
    selectChangeVal(data) {
      console.debug('selectChangeVal:', data)
      let state = ''
      if (data.state === 'phaseType') {
        this.curSelect_phaseType = data.val
      } else if (data.state === 'statsType') {
        state = 'resetColumnData'
        this.curSelect_statsType = data.val
      }
      console.debug(this.curSelect_phaseType)
      this.getPlayerDetailCereerList(state)
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      let className = ''
      if (row.isPlay === 0 && columnIndex == 1) {
        className = 'unPlayRow'
      } else {
        this.tableCustomCellRender.props.forEach((cellItem) => {
          if (column.property === cellItem) {
            className = 'cell_clo2Row'
          }
        })
      }
      return className
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.isPlay === 0) {
        if (columnIndex === 1) {
          return [1, 16]
        } else if (columnIndex > 1) {
          return [0, 0]
        }
      }
    },
    formatTableDataHandler(res) {
      if (
        res.data &&
        res.data.middle &&
        res.data.datas &&
        res.data.datas.length
      ) {
        const leftColumns = res.data.left
        const middleColumns = res.data.middle
        const rightColumns = res.data.right
        // const fristColumns_left = leftColumns.slice(0, 3)
        // const otherColumns_left = leftColumns.slice(3)
        this.defaultWidthVwNum = res.data.middle.length
        this.defaultWidthVwNum =
          res.data.middle.length + res.data.left.length - 2 //减去【赛季+球队】特殊宽度的2列
        if (this.tableColumnData.length == 0) {
          let tableColumnData = []
          let leftColumnObjArr = []
          let rightColumnObjArr = []
          if (leftColumns) {
            for (let i = 0; i < leftColumns.length; i++) {
              const item = leftColumns[i]
              let widthVw = this.tableCellDefaultWidthVw
              if (item.colKey === 'teamName') {
                widthVw = this.variableColWidthVw
              } else if (item.colKey === 'seasonName') {
                widthVw = this.variableColWidthVw
              }
              leftColumnObjArr.push({
                prop: item.colKey, //fristColumnPropArr.join('-'),
                label: item.colTitle,
                widthVw, //对应列的宽度，单位vw
                className: '', //单独定制的头部样式class
                fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
              })
            }
          }

          // const fristColumn = {
          //   prop: 'leftTeamName', //fristColumnPropArr.join('-'),
          //   label: '球队',
          //   widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
          //   className: 'columnTeamNameClass', //单独定制的头部样式class
          //   fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          // }

          tableColumnData = [].concat(leftColumnObjArr)
          for (let i = 0; i < middleColumns.length; i++) {
            const item = middleColumns[i]
            tableColumnData.push({
              prop: item.colKey,
              label: item.colTitle,
              widthVw: this.tableCellDefaultWidthVw, //对应列的宽度，单位vw
              className: '', //单独定制的头部样式class
              selected: item.selected,
            })
          }

          if (rightColumns) {
            for (let i = 0; i < rightColumns.length; i++) {
              rightColumnObjArr.push({
                prop: item.colKey,
                label: item.colTitle,
                widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                className: 'columnTeamNameClass', //单独定制的头部样式class
                fixed: 'right', //是否锁定，如果开启不滚动，此字段无效
              })
            }
          }

          this.tableColumnData = [].concat(tableColumnData, rightColumnObjArr)
        }
        this.tableData = res.data ? res.data.datas : []
        console.debug('this.tableData:', this.tableData)
      } else {
        console.debug('暂无数据')
        this.tableData = []
      }
    },
    async getPlayerDetailCereerList(state) {
      await https_playerDetail_careerData(this.axiosBaseUrl, this.$axios, {
        cid: this.currCid,
        phid: this.curSelect_phaseType,
        pid: this.query.pid,
        stat: this.curSelect_statsType,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (state === 'resetColumnData') {
              this.tableColumnData = []
            }
            this.formatTableDataHandler(res)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
#basketball_playerDetail_careeData {
  padding-bottom: 2.778vw;
  .select_row_box {
    padding: 2.778vw 0 1.388vw 0;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    & > div {
      margin-right: 0.694vw;
    }
  }
  .group_container {
    width: 100%;
    .group_box {
      padding: 1.388vw 0 2.778vw 0;
      .teamName {
        display: block;
        padding-bottom: 0.974vw;
        font-size: 1.25vw;
        font-weight: bold;
      }
    }

    .noDataClass {
      display: block;
      width: 100%;
      line-height: 5.55vw;
      text-align: center;
      font-size: 0.972vw;
      color: var(--mixtmt_greyColor2);
    }
    .noDataClass {
      border-top: 1px solid var(--mixtmt_greyColor0);
      border-bottom: 1px solid var(--mixtmt_greyColor0);
    }
  }
}
</style>
